"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeSegment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var segment_dropdown_1 = require("../../../../components/form/segment-dropdown");
var main_1 = require("../../../../reducers/slices/main");
var ChallengeSegment = function (_a) {
    var on_save = _a.on_save, excluded_segment_ids = _a.excluded_segment_ids;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_2.useState)(""), segmentId = _b[0], setSegmentId = _b[1];
    var _c = (0, react_2.useState)(false), runForCurrentMembers = _c[0], setRunForCurrentMembers = _c[1];
    var _d = (0, react_2.useState)(false), isSaving = _d[0], setIsSaving = _d[1];
    var _e = (0, react_2.useState)(""), error = _e[0], setError = _e[1];
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!segmentId) {
                        setError("Please select a segment");
                        return [2 /*return*/];
                    }
                    setIsSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, on_save(segmentId, runForCurrentMembers)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6 py-2", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-full max-w-[360px]", children: (0, jsx_runtime_1.jsx)(segment_dropdown_1.SegmentDropdown, { label: "Segment", selected_ids: segmentId ? [segmentId] : [], on_selection_change: function (segmentIds) {
                        var _a;
                        setSegmentId((_a = segmentIds[0]) !== null && _a !== void 0 ? _a : "");
                        setError("");
                    }, excluded_ids: excluded_segment_ids, is_invalid: !!error, error_message: error }) }), (0, jsx_runtime_1.jsxs)(react_1.Checkbox, { isSelected: runForCurrentMembers, onChange: setRunForCurrentMembers, children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, {}) }), (0, jsx_runtime_1.jsx)(react_1.Checkbox.Content, { children: (0, jsx_runtime_1.jsx)(react_1.Label, { children: "Grant to current members too" }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row gap-6 justify-center items-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "secondary", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "primary", isPending: isSaving, onPress: handleSave, children: "Done" })] })] }));
};
exports.ChallengeSegment = ChallengeSegment;
